import { useLocation, useNavigate } from 'react-router-dom';
import { isNativeApp } from '../services/platform-service.js';

// 공유 링크로 열리는 화면(디자인 상세·공유·컬렉션)의 back 버튼 판단.
//
// 링크를 받고 **웹에서** 바로 연 사람에게는 back 을 아예 안 그린다. 뒤로 갈
// 곳이 우리 화면 중에는 없고, `navigate(-1)` 은 이 사람을 메신저나 검색
// 결과로 되돌려 보낸다. `/` 로 떨어뜨리는 fallback 도 지금은 /landing 이라
// 디자인 보러 온 사람을 마케팅 페이지로 보내는 꼴이다. 둘 다 back 이라는
// 이름이 약속하는 동작이 아니다.
//
// 판별은 `location.key` 로 한다. react-router 는 **그 탭에서 처음 연 항목**의
// key 를 'default' 로 둔다. 즉 'default' = 딥링크·새 탭·주소창 직접 입력이고,
// 그 외 = 우리 앱 안에서 넘어온 것. `window.history.length` 는 같은 탭에서
// 방문한 **다른 사이트**까지 세기 때문에 이 판단에는 못 쓴다 (링크 하나 타고
// 들어와도 3, 4 가 나온다).
//
// 네이티브 앱에서는 항상 그린다 — 딥링크로 들어왔어도 나갈 곳이 앱 안에
// 있고, back 이 없으면 그 화면에 갇힌다.
export function useInAppBack(fallback = '/create') {
  const navigate = useNavigate();
  const location = useLocation();
  const cameFromInApp = location.key !== 'default';

  return {
    showBack: isNativeApp() || cameFromInApp,
    goBack: () => {
      if (cameFromInApp) navigate(-1);
      else navigate(fallback);
    },
  };
}
